import { useRef, useEffect } from 'react';

export const FloorReflection = ({
  children,
  reflectionOpacity = 0.3,
  reflectionHeight = '100%',
  gap = 0,
  skew = 0,
  fadeRate = 100,
  disabled = false,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const reflectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const content = contentRef.current;
    const reflection = reflectionRef.current;
    if (!content || !reflection) {
      return;
    }

    const updateReflection = () => {
      reflection.innerHTML = '';
      const clone = content.cloneNode(true);
      reflection.appendChild(clone);
    };

    updateReflection();

    const observer = new MutationObserver(updateReflection);
    observer.observe(content, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true,
    });

    return () => observer.disconnect();
  }, [children]);

  if (disabled) {
    return <>{children}</>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div ref={contentRef}>{children}</div>

      {gap > 0 && <div style={{ height: gap }} />}

      <div
        ref={reflectionRef}
        style={{
          transform: `scaleY(-1) skewX(${skew}deg)`,
          opacity: reflectionOpacity,
          height: reflectionHeight,
          overflow: 'hidden',
          maskImage: `linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,0) ${fadeRate}%)`,
          WebkitMaskImage: `linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,0) ${fadeRate}%)`,
          pointerEvents: 'none',
          marginLeft: skew ? `calc(${skew * -1}px * 9 - 9px)` : undefined,
        }}
      />
    </div>
  );
};
